var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DxSelectBox',{class:_vm.inputClass,attrs:{"data-source":_vm.codeList,"value":"","read-only":_vm.readOnly,"disabled":_vm.disabled,"display-expr":"cmnsCdNm","value-expr":"cmnsCd"},on:{"value-changed":_vm.onChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ee5e131","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DxSelectCodeList.vue
// module id = null
// module chunks = 